import {
  keepPreviousData,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  ArticleProductionStepSearchQueryForm,
  ArticleProductionStepSearchReplyListElement,
} from './article-steps-copy.models';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {Lister} from '../../../common/wrapper.models';
import {environment} from '../../../../environments/environment';
import {articleStepsCopyListQueryKeys} from './article-steps-copy-list-query-keys';

export function useArticleStepsCopyListQuery(
  query: ArticleProductionStepSearchQueryForm,
): UseQueryResult<Lister<ArticleProductionStepSearchReplyListElement>> {
  return useQuery({
    queryKey: articleStepsCopyListQueryKeys.filter(query),
    queryFn: () =>
      AxiosHttpClient.get<Lister<ArticleProductionStepSearchReplyListElement>>(
        `${environment.apiv4uri}article/list/production/copyable`,
        query),
    placeholderData: keepPreviousData,
  });
}
